module.exports = __webpack_public_path__ + "assets/img/XJ.99215d7b.png";